import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-animated-bg">
        <div className="not-found-circle not-found-circle-1"></div>
        <div className="not-found-circle not-found-circle-2"></div>
      </div>
      <div
        className="not-found-wrapper"
        data-aos="fade-up"
        data-aos-duration="600"
      >
        <div className="not-found-content">
          <div className="not-found-illustration">
            <div className="not-found-number">404</div>
          </div>
          <h1>Page Not Found</h1>
          <p>The page you're looking for doesn't exist or has been moved.</p>
          <div className="not-found-actions">
            <Link to="/" className="home-button">
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
